import { QueryClient } from "@tanstack/react-query";

// polling (refetchInterval) pauses while the tab is hidden, refetchIntervalInBackground stays false
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: 1,
      staleTime: 10 * 1000,
    },
  },
});

// after a transaction every value on screen may have changed (balances, reserves, rewards)
export const invalidateAfterTransaction = () => queryClient.invalidateQueries();
